export class PhotovoltaikcheckConstants {
  static readonly PHOTOVOLTAIKCHECK = 'photovoltaikcheck';

  /**
   * key for the azure maps api.
   * This key is created in the azure portal by co2online admins.
   * To revoke or replace the key you have to edit the azure ressource "Ratgeber"
   *
   */
  static readonly AZURE_MAPS_KEY = '5INXQIKvEuSLGQCP0ySGCRxxha124NEd90vpmzFeQHSIl2JdtBCeJQQJ99CAAC5RqLJUdRonAAAgAZMP2PuF';

  /**
   * Some defaults
   */
  static readonly VALIDATE_DACHNEIGUNG_DEFAULT = 45;

  /**
   * Some validation constants
   */
  static readonly VALIDATE_FLAECHE_VERFUEGBAR_MIN = 5;
  static readonly VALIDATE_FLAECHE_VERFUEGBAR_MAX = 500;
  static readonly VALIDATE_STOCKWERKE_MIN = 1;
  static readonly VALIDATE_STOCKWERKE_MAX = 30;
  static readonly VALIDATE_CONSUMPTION = 10000;
  static readonly VALIDATE_CONSUMPTION_PUMP = 10000;
  static readonly VALIDATE_CONSUMPTION_ECAR = 2500;

  /**
   * Paths of the advisor
   */
  static readonly PATH_PVANLAGE = 'photovoltaikanlage';
  static readonly PATH_BALKONKRAFTWERK = 'balkonkraftwerk';

  /**
   * Some optiona values that are used on severel occasions
   */
  static readonly GEBAEUDETYP_EFH = '1-2familienhaus';
  static readonly GEBAEUDETYP_MFH = 'mehrfamilienhaus';
  static readonly NUTZUNGSTYP_HAUSEIGENTUEMER = 'hauseigentuemer';
  static readonly NUTZUNGSTYP_WOHNUNGSEIGENTUEMER = 'wohnungseigentuemer';
  static readonly NUTZUNGSTYP_MIETER = 'mieter';
  static readonly NUTZUNGSTYP_HAUSVERWALTER = 'hausverwalter';
  static readonly AUFSTELLORT_SPITZDACH = 'spitzdach';
  static readonly AUFSTELLORT_PULTDACH = 'pultdach';
  static readonly AUFSTELLORT_FLACHDACH = 'flachdach';
  static readonly AUFSTELLORT_FASSADE = 'fassade';
  static readonly AUFSTELLORT_BALKON = 'balkon';
  static readonly AUFSTELLORT_FREIFLAECHE = 'freiflaeche';

  /**
   * List of modes for the area calculation
   */
  static readonly MODE_FLAECHE = 'flaeche_verfuegbar';
  static readonly MODE_WOHNFLAECHE = 'wohnflaeche';
  static readonly MODE_STOCKWERKE = 'stockwerke';

  /**
   * some fieldnames for the area calculation
   */
  static readonly FIELD_FLAECHE_KARTE = 'flaeche_karte';
  static readonly FIELD_FLAECHE_WOHNFLAECHE = 'flaeche_wohnflaeche';
  static readonly FIELD_DRAWAREA = 'drawarea';
  static readonly FIELD_ADDRESS = 'address';

  /**
   * some map configuration
   */
  static readonly MAP_MAX_ZOOM = 20;
  static readonly MAP_GELOCATION_ZOOM = 15;
  static readonly MAP_ADDRESSSEARCH_ZOOM = 18;
  static readonly MAP_PROJECTION = 'EPSG:3857';
  static readonly MAP_ADDRESS_MINLENGTH = 3;

  /**
   * some calculator configuration
   */
  static readonly FLOOR_CALCULATOR_AREA_FACTOR = 1.2;
  static readonly FLOOR_CALCULATOR_SPITZDACH_FACTOR = 1.5;
  static readonly FLOOR_CALCULATOR_PULTDACH_FACTOR = 1.15;

  /**
   * own equity
   */
  static readonly OWN_EQUITY_MIN = 3000;

  /**
   * Some names of configurations
   */
  static readonly OPTIMIERUNG_POSTFIX_VOLLEINSPEISUNG: string = '_volleinspeisung';
}
